import React from 'react';
import { Link } from 'react-navi';

interface NavigationProps {
    additional: any;
}

const Navigation: React.FC<NavigationProps> = props => (
    <div className="tabs as-navigation is-centered is-family-futura mb-0 has-background-dark">
        <ul>
            <li>
                <Link href="/entries/finalist">FINALISTS</Link>
            </li>

            <li>
                <Link href="/#event">EVENT</Link>
            </li>

            <li className="is-hidden-mobile">
                <Link href="/#history">HISTORY</Link>
            </li>
          {/*
                      <li>
                <Link href="/entry">ENTRY</Link>
            </li>
          */}
            {props.additional}
        </ul>
    </div>
);

export default Navigation;
